import React, { useCallback } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CollapsibleV2 from 'Components/CollapsibleV2/CollapsibleV2';

import css from './CollapsibleFilter.scss';

import { addFilterPreference } from 'Actions/filtersPreferences';

export const CollapsibleFilter = ({
    addFilterPreference,
    filter,
    isInitiallyOpen,
    children
}) => {
    const onStateToggle = useCallback(isOpen => {
        addFilterPreference({
            [filter.id]: { collapsed: !isOpen }
        });
    }, [addFilterPreference, filter.id]);

    return (
        <CollapsibleV2
            key={ `${filter.id}` }
            data-aut-id={ `collapsibleFilter_${filter.attribute}` }
            className={ css.collapsibleFilter }
            titleClassName={ css.title }
            title={ filter.name }
            onClick={ onStateToggle }
            isInitiallyOpen={ isInitiallyOpen }
        >
            { children }
        </CollapsibleV2>
    );
};

CollapsibleFilter.propTypes = {
    addFilterPreference: PropTypes.func,
    filter: PropTypes.object.isRequired,
    isInitiallyOpen: PropTypes.bool,
    children: PropTypes.element
};

CollapsibleFilter.defaultProps = {
    addFilterPreference: () => {},
    isInitiallyOpen: true,
    children: null
};

export const mapDispatchToProps = {
    addFilterPreference
};

export default compose(
    connect(null, mapDispatchToProps),
    React.memo
)(CollapsibleFilter);
